import React from 'react';
import { Search } from 'lucide-react';
import { STATUS_OPTIONS } from '../utils/reportConstants';

const ReportFilters = ({ 
  filters, 
  technicians, 
  onSearchChange, 
  onStatusChange, 
  onTechnicianChange 
}) => {
  const { searchTerm, statusFilter, technicianFilter } = filters;

  return (
    <div className="bg-white p-4 rounded-lg border space-y-4">
      <div className="flex flex-col md:flex-row gap-4">
        {/* Search */}
        <div className="flex-1 relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
          <input
            type="text"
            placeholder="Search by report number, customer, or findings..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        {/* Status Filter */}
        <select
          value={statusFilter}
          onChange={(e) => onStatusChange(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          {STATUS_OPTIONS.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        {/* Technician Filter */}
        <select
          value={technicianFilter}
          onChange={(e) => onTechnicianChange(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          <option value="">All Technicians</option>
          {technicians.map(tech => (
            <option key={tech.id} value={tech.id}>
              {tech.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ReportFilters;